import { Navigate } from 'react-router-dom';
import { ClassesList } from '../modules/classes/ClassesList';
import { ClassEdit } from '../modules/classes/ClassEdit';
import { ClassesPreview } from '../modules/classes/ClassesPreview';
import { CLassExercisesEdit } from '../modules/classes/ClassExercisesEdit';
import { PeriodizationsList } from '../modules/periodizations/PeriodizationsList';
import { PeriodizationEdit } from '../modules/periodizations/PeriodizationEdit';
import { ExercisesList } from '../modules/exercises/ExercisesList';
import { EditExerciseType } from '../modules/exercisetypes/EditExerciseType';
import { EditExercise } from '../modules/exercises/EditExercise';
import { ExerciseTypesList } from '../modules/exercisetypes/ExerciseTypesList';
import { TargetAreasList } from '../modules/targetareas/TargetAreasList';
import { EditTargetArea } from '../modules/targetareas/CreateTargetArea';
import { EquipmentsList } from '../modules/equipments/EquipmentsList';
import { EditEquipment } from '../modules/equipments/EditEquipment';
import { WorkoutsList } from '../modules/workouts/WorkoutsList';
import { EditWorkout } from '../modules/workouts/EditWorkout';
import { MovementsList } from '../modules/movements/MovementsList';
import { GroupRoutineEdit } from '../modules/grouproutines/GroupRoutineEdit';
import { MovementEdit } from '../modules/movements/MovementEdit';
import { GroupRoutineList } from '../modules/grouproutines/GroupRoutineList';
import { TrainersList } from '../modules/trainers/TrainersList';
import { EditTrainers } from '../modules/trainers/EditTrainers';
import { StudioList } from '../modules/studios/StudiosList';
import { EditStudio } from '../modules/studios/EditStudio';

export const RoutingConfig = [
    { path: '/', element: <Navigate to='/classes' /> },
    { path: '/classes', element: <ClassesList /> },
    { path: '/classes/create', element: <ClassEdit mode='create' /> },
    { path: '/classes/edit', element: <ClassEdit mode='edit' /> },
    { path: '/classes/preview', element: <ClassesPreview /> },
    { path: '/classes/exercises/edit', element: <CLassExercisesEdit /> },
    { path: '/periodizations', element: <PeriodizationsList /> },
    { path: '/periodizations/exercises/edit', element: <CLassExercisesEdit /> },
    { path: '/periodizations/create', element: <PeriodizationEdit mode='create' /> },
    { path: '/periodizations/edit/:id', element: <PeriodizationEdit mode='edit' /> },
    { path: '/periodizations/preview', element: <ClassesPreview /> },
    { path: '/exercises', element: <ExercisesList /> },
    { path: '/exercises/create', element: <EditExercise mode='create' /> },
    { path: '/exercises/edit/:id', element: <EditExercise mode='edit' /> },
    { path: '/exercisetypes', element: <ExerciseTypesList /> },
    { path: '/exercisetypes/create', element: <EditExerciseType mode='create' /> },
    { path: '/exercisetypes/edit/:id', element: <EditExerciseType mode='edit' /> },
    { path: '/targetareas', element: <TargetAreasList /> },
    { path: '/targetareas/create', element: <EditTargetArea mode='create' /> },
    { path: '/targetareas/edit/:id', element: <EditTargetArea mode='edit' /> },
    { path: '/equipments', element: <EquipmentsList /> },
    { path: '/equipments/create', element: <EditEquipment mode='create' /> },
    { path: '/equipments/edit/:id', element: <EditEquipment mode='edit' /> },
    { path: '/workouts', element: <WorkoutsList /> },
    { path: '/workouts/create', element: <EditWorkout mode='create' /> },
    { path: '/workouts/edit/:id', element: <EditWorkout mode='edit' /> },
    { path: '/movements', element: <MovementsList /> },
    { path: '/movements/create', element: <MovementEdit mode='create' /> },
    { path: '/movements/edit/:id', element: <MovementEdit mode='edit' /> },
    { path: '/warmups', element: <GroupRoutineList phase='warmup' /> },
    { path: '/warmups/create', element: <GroupRoutineEdit mode='create' phase='warmup' /> },
    { path: '/warmups/edit/:id', element: <GroupRoutineEdit mode='edit' phase='warmup' /> },
    { path: '/grouproutines', element: <GroupRoutineList phase='workout' /> },
    { path: '/grouproutines/create', element: <GroupRoutineEdit mode='create' phase='workout' /> },
    { path: '/grouproutines/edit/:id', element: <GroupRoutineEdit mode='edit' phase='workout' /> },
    { path: '/trainers', element: <TrainersList /> },
    { path: '/trainers/create', element: <EditTrainers mode='create' /> },
    { path: '/trainers/edit/:id', element: <EditTrainers mode='edit' /> },
    { path: '/studios', element: <StudioList /> },
    { path: '/studios/create', element: <EditStudio mode='create' /> },
    { path: '/studios/edit/:id', element: <EditStudio mode='edit' /> }
];